export { Select } from "@mantine/core";
export type { SelectProps, SelectItem as SelectOption } from "@mantine/core";
export { SelectItem } from "./SelectItem";
export { getSelectOverrides } from "./Select.styled";
